import {
  ADD_ITEM_TO_PROGRESS_LIST,
  REMOVE_ITEM_FROM_PROGRESS_LIST,
  CLEAR_PROGRESS_LIST
} from "../types";

export const addProgressItem = item => ({
  type: ADD_ITEM_TO_PROGRESS_LIST,
  cancelSourceData: item
});

export const removeProgressItem = item => ({
  type: REMOVE_ITEM_FROM_PROGRESS_LIST,
  cancelSourceData: item
});

export const clearProgressItems = () => ({
  type: CLEAR_PROGRESS_LIST
});

export const addItemToProgress = item => dispatch => {
  dispatch(addProgressItem(item));
};

export const removeItemFromProgress = item => dispatch => {
  dispatch(removeProgressItem(item));
};

export const clearProgressList = () => dispatch => {
  dispatch(clearProgressItems());
};



// WEBPACK FOOTER //
// ./src/actions/progressList.js